import {DatePicker, Button as AntdButton, Form, Input, Table} from 'antd';
import styles from './customerSucessHub.module.scss';
import {Button} from '@dabafinance/react-components';
import {useEffect, useState} from 'react';
import {useQuery} from '@apollo/client';
import {
  GET_ALL_TEAM_INTERACTIONS,
  GET_TEAM_INTERACTIONS_SUMMARY,
} from './resolvers';
import {toast} from 'react-toastify';
import PercentageCard from 'pages/adminUser/card/PercentageCard';
import moment from 'moment';
import {useSelector} from 'react-redux';
import SubmitButton from 'components/Startup/components/SubmitButton';
import DBModal from 'components/modal/modal';
import {fieldRules} from 'utils/helper';
import {client} from 'index';
import {useNavigate} from 'react-router-dom';
import {UserSelectField} from 'components/userSelectField/UserSelectField';
import {NavTabsEnum} from 'utils/constants';
import {makeSelectTabOperations} from 'redux/store/auth';
import UserLink from 'components/userLink/UserLink';
import {Avatar} from 'antd';
import {UserOutlined} from '@ant-design/icons';

export const CustomerSuccessHub = () => {
  const adminRole = useSelector(
    state => state?.auth?.userData?.user?.activeAdminTab?.name,
  );

  const {
    data,
    loading,
    form,
    handleExport,
    activeTab,
    handleDateFilter,
    setActiveTab,
    openExportModal,
    setOpenExportModal,
    exportForm,
    currentPage,
    handlePageChange,
    limit,
    totalPages,
    agent,
    setAgent,
  } = customerSuccessHook({adminRole});

  const navigate = useNavigate();

  const tabOperations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.AgentHub),
  );

  const columns = [
    {
      title: 'User',
      dataIndex: 'name',
      key: 'name',
      render: (text, record) => {
        const userId = record?.user?.id;
        const name = [record?.user?.firstName, record?.user?.lastName]
          .filter(Boolean)
          .join(' ')
          .trim();
        return (
          <div className={styles.userCell}>
            <Avatar src={record?.user?.imageUrl} icon={<UserOutlined />} />
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <span className={styles.userName}>
                <UserLink userId={userId} tab="interactions">
                  {name || record?.user?.email || record?.user?.id || '—'}
                </UserLink>
              </span>
              <span className={styles.userEmail}>
                {record?.user?.email || '—'}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      title: 'Total Interactions',
      dataIndex: 'totalInteraction',
    },
    {
      title: 'Last Interaction',
      dataIndex: 'lastInteraction',
      render: (text, record) => (
        <span>
          {moment(record?.lastInteraction).format('DD MMM, YYYY hh:mm A')}
        </span>
      ),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
      render: (text, record) => (
        <AntdButton
          onClick={() => {
            navigate(`/dashboard/user/${record?.user?.id}/interactions`);
          }}>
          View
        </AntdButton>
      ),
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Agents Interactions</h1>
        <p>Track and manage your interactions and sales activities</p>
      </div>
      <div className={styles.content}>
        <div className={styles.top}>
          <Form
            form={form}
            className={styles.form}
            onFinish={handleDateFilter}
            layout="horizontal">
            {adminRole === 'SUPERADMIN' && (
              <Form.Item name="agent" className={styles.search}>
                <UserSelectField
                  users={agent}
                  setUsers={setAgent}
                  placeholder="Search and Select Agent"
                  mode="single"
                  admin
                />
              </Form.Item>
            )}
            <Form.Item name="startDate">
              <DatePicker placeholder="Start Date" showTime />
            </Form.Item>
            <Form.Item name="endDate">
              <DatePicker placeholder="End Date" showTime />
            </Form.Item>
            <SubmitButton disabled={loading} label="Filter" smallWidth />
          </Form>

          <Button
            label="Export"
            disabled={!tabOperations?.export}
            onClick={() => setOpenExportModal({open: true, email: null})}
          />
        </div>
        <div className={styles['details-toggler']}>
          {adminRole !== 'SUPERADMIN' && (
            <span
              className={activeTab === 'myInteractions' ? styles.active : ''}
              onClick={() => {
                setActiveTab('myInteractions');
                form.resetFields();
                exportForm.resetFields();
              }}>
              My Interactions
            </span>
          )}
          <span
            className={activeTab === 'allInteractions' ? styles.active : ''}
            onClick={() => {
              setActiveTab('allInteractions');
              form.resetFields();
              exportForm.resetFields();
            }}>
            Team Interactions
          </span>
        </div>
        <div className={styles.cards}>
          <PercentageCard
            active
            loading={loading}
            label="Total Interactions"
            amount={data?.statistics?.totalInteractions}
          />
          <PercentageCard
            loading={loading}
            label="Total KYC Completed"
            amount={data?.statistics?.totalKycCompleted}
          />
          <PercentageCard
            loading={loading}
            label="Total Successful Deposits"
            amount={data?.statistics?.totalSuccessfulDeposits}
          />
          <PercentageCard
            loading={loading}
            label="Total Successful Investments"
            amount={data?.statistics?.totalSuccessfulInvestment}
          />
          <PercentageCard
            loading={loading}
            label="Total DabaPro Sold"
            amount={data?.statistics?.totalDabaProSold}
          />
        </div>
        <div>
          <Table
            loading={loading}
            dataSource={data?.summary}
            columns={columns}
            pagination={{
              current: currentPage,
              total: totalPages,
              onChange: handlePageChange,
              showSizeChanger: true,
              pageSize: limit,
            }}
          />
        </div>
      </div>
      <DBModal
        isOpen={openExportModal.open}
        handleClose={() => setOpenExportModal({open: false, email: null})}
        content={
          <div className={styles.exportModal}>
            <div className={styles.exportHeader}>
              <h2>Export (Team Interactions)</h2>
              <p>Note that the export is based on filters if applied.</p>
            </div>
            <Form form={exportForm} layout="vertical">
              <Form.Item
                rules={[
                  fieldRules('Email'),
                  {type: 'email', message: 'Invalid email address'},
                ]}
                label="Email"
                name="email">
                <Input placeholder="Email" />
              </Form.Item>
              <div className="buttons">
                <Button
                  label="Cancel"
                  onClick={() => setOpenExportModal({open: false, email: null})}
                />
                <Button
                  type="secondary"
                  label="Export"
                  onClick={handleExport}
                  disabled={loading}
                />
              </div>
            </Form>
          </div>
        }
      />
    </div>
  );
};

const customerSuccessHook = ({adminRole}) => {
  const [form] = Form.useForm();
  const [exportForm] = Form.useForm();
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [activeTab, setActiveTab] = useState(
    adminRole !== 'SUPERADMIN' ? 'myInteractions' : 'allInteractions',
  );
  const [agent, setAgent] = useState(null);
  const [openExportModal, setOpenExportModal] = useState({
    open: false,
    email: null,
  });

  const RESOLVER =
    activeTab === 'allInteractions'
      ? GET_ALL_TEAM_INTERACTIONS
      : GET_TEAM_INTERACTIONS_SUMMARY;

  useEffect(() => {
    setLimit(10);
    setCurrentPage(1);
  }, [activeTab]);

  const {data, refetch, loading} = useQuery(RESOLVER, {
    errorPolicy: 'all',
    onError: error => toast.error(error.message),
    variables: {
      filter: {
        page: 1,
        limit: 10,
        paginate: true,
      },
    },
    fetchPolicy: 'no-cache',
    notifyOnNetworkStatusChange: true,
  });

  const handleExport = () => {
    client
      .query({
        query: RESOLVER,
        variables: {
          filter: {
            emails: [exportForm.getFieldsValue().email],
            export: true,
            createdBy: agent ? agent?.split(';')[2] : null,
            startDate: form.getFieldsValue().startDate
              ? moment(form.getFieldsValue().startDate).format()
              : null,
            endDate: form.getFieldsValue().endDate
              ? moment(form.getFieldsValue().endDate).format()
              : null,
          },
        },
        fetchPolicy: 'no-cache',
        notifyOnNetworkStatusChange: true,
        onError: error => toast.error(error.message),
      })
      .then(({data}) => {
        const resolvedData =
          data?.[
            activeTab === 'allInteractions'
              ? 'getOwnInteractionSummary'
              : 'getTeamInteractionSummary'
          ];
        if (
          resolvedData?.statusCode === 400 ||
          resolvedData?.__typename === 'Error'
        ) {
          toast.error(resolvedData.message);
        } else {
          toast.success('Data exported successfully');
          setOpenExportModal({open: false, email: null});
          exportForm.resetFields();
        }
      })
      .catch(error => toast.error(error.message));
  };

  const handleDateFilter = values => {
    setCurrentPage(1);
    const startDate = values.startDate
      ? moment(values.startDate).format()
      : null;
    const endDate = values.endDate ? moment(values.endDate).format() : null;
    refetch({
      filter: {
        page: 1,
        limit: 10,
        startDate,
        endDate,
        createdBy: agent ? agent?.split(';')[2] : null,
        paginate: true,
      },
    });
  };

  const handlePageChange = (page, pageSize) => {
    if (page === currentPage && pageSize === limit) return;
    setCurrentPage(page);
    setLimit(pageSize);
    refetch({
      filter: {
        page,
        limit: pageSize,
        createdBy: agent ? agent?.split(';')[2] : null,
        paginate: true,
        startDate: form.getFieldsValue().startDate
          ? moment(form.getFieldsValue().startDate).format()
          : null,
        endDate: form.getFieldsValue().endDate
          ? moment(form.getFieldsValue().endDate).format()
          : null,
      },
    });
  };

  return {
    data:
      activeTab === 'allInteractions'
        ? data?.getCumulativeInteractionSummary?.data
        : data?.getAdminInteractionSummary?.data,
    loading,
    activeTab,
    setActiveTab,
    form,
    openExportModal,
    agent,
    setAgent,
    setOpenExportModal,
    exportForm,
    handleDateFilter,
    handleExport,
    totalPages:
      activeTab === 'allInteractions'
        ? data?.getCumulativeInteractionSummary?.pagination?.total
        : data?.getAdminInteractionSummary?.pagination?.total,
    currentPage,
    handlePageChange,
    limit,
  };
};
